import { Layout } from "@/components/layout"
import QmsApp from "@/features/qms-ingestion/App"
import "@/features/qms-ingestion/index.css"

export default function QmsIngestionPage() {
  return (
    <Layout>
      <QmsApp />
    </Layout>
  )
}
